/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_PromptInputs */

const en_explorer_search_prompt = /** @type {(inputs: Explorer_Search_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a query or filters to search storage.`)
};

const fr_explorer_search_prompt = /** @type {(inputs: Explorer_Search_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a query or filters to search storage.`)
};

const de_explorer_search_prompt = /** @type {(inputs: Explorer_Search_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a query or filters to search storage.`)
};

const it_explorer_search_prompt = /** @type {(inputs: Explorer_Search_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a query or filters to search storage.`)
};

const ru_explorer_search_prompt = /** @type {(inputs: Explorer_Search_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a query or filters to search storage.`)
};

const es_explorer_search_prompt = /** @type {(inputs: Explorer_Search_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a query or filters to search storage.`)
};

const zh_cn2_explorer_search_prompt = /** @type {(inputs: Explorer_Search_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a query or filters to search storage.`)
};

const ja_explorer_search_prompt = /** @type {(inputs: Explorer_Search_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a query or filters to search storage.`)
};

const hi_explorer_search_prompt = /** @type {(inputs: Explorer_Search_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a query or filters to search storage.`)
};

const pt_pt2_explorer_search_prompt = /** @type {(inputs: Explorer_Search_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a query or filters to search storage.`)
};

/**
* | output |
* | --- |
* | "Enter a query or filters to search storage." |
*
* @param {Explorer_Search_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_prompt = /** @type {((inputs?: Explorer_Search_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_search_prompt(inputs)
	if (locale === "de") return de_explorer_search_prompt(inputs)
	if (locale === "it") return it_explorer_search_prompt(inputs)
	if (locale === "ru") return ru_explorer_search_prompt(inputs)
	if (locale === "es") return es_explorer_search_prompt(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_search_prompt(inputs)
	if (locale === "ja") return ja_explorer_search_prompt(inputs)
	if (locale === "hi") return hi_explorer_search_prompt(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_search_prompt(inputs)
	return en_explorer_search_prompt(inputs)
});